<div class="over-ask-sgp-pick">
    <div class="list-title-container">
        <div class="title-container">
            <div class="title-header">
                {{ headerText() }}
            </div>
            <div class="title-odds">
                {{ groupPrice() }}
            </div>
        </div>
        <div class="event-name">
            <span class="name">{{ eventName() }}</span>
            <span class="event-name-seperator"></span>
            <span class="date">{{ date() }} </span>
        </div>
    </div>
    <div>
        @for (pick of pickList(); track pick.id) {
            <div class="over-ask-sgp-pick-items">
                <div class="over-ask-sgp-pick-item">
                    <div class="circle-overlay"><div class="theme-radio-off"></div></div>
                    <div class="option-market-list">
                        <div class="option-name">{{ optionName(pick) }}</div>
                        <div class="market-name">{{ marketName(pick) }}</div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
